// File: components/layout/ContentArea.js

import React from 'react';

/**
 * ContentArea Component
 * 
 * Wrapper for main content with proper spacing and structure
 * Provides consistent padding and max-width for content
 * 
 * Props:
 * - children: Content to display
 * - className: Additional CSS classes
 * - maxWidth: Custom max-width (default: 'standard')
 *   - 'narrow': 720px (articles, forms)
 *   - 'standard': 900px (default)
 *   - 'wide': 1200px (dashboards)
 *   - 'full': 100% (full width)
 * - noPadding: Remove default padding
 */
const ContentArea = ({ 
    children,
    className = '',
    maxWidth = 'standard',
    noPadding = false
}) => {
    // Build class names
    const classNames = [
        'content-area',
        `max-width-${maxWidth}`,
        noPadding ? 'no-padding' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <div className={classNames}>
            {children}
        </div>
    );
};

export default ContentArea;
